module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAElBMVEUsLCxHcEwsLCwsLCwpKSksLCw7u7lzAAAABXRSTlOAAEDARLlcaSQAAAB/SURBVCjPfVHJDYAwDDMP/g1igY7Agz0q2H8XaMlRORJ9NE7i3BB6yIY6q1Wwt0kv18tYlzC8GFKC0iFkonQECcoAkKAMCXHKJ+Au/eE+5cGjNRMs3GrBClgpNZS70fjnIf8MzpGqcB+pU54lTcv7SBvjnaat8122dDm+LV//AQf/Jr9IzhXjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/NCAcmi_close.png
// module id = NNNF
// module chunks = 0